import { whyChooseUsContent } from '../../data/index';

export default {
    name: 'whyChooseUsSectionId',
    title: 'Why Choose Us Section',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            validation: Rule => Rule.required(),
            initialValue: whyChooseUsContent.title
        },
        {
            name: 'points',
            title: 'Points',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
                        { name: 'description', title: 'Description', type: 'text', validation: Rule => Rule.required() }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: whyChooseUsContent.points
        },
        {
            name: 'image',
            title: 'Image',
            type: 'image',
            options: { hotspot: true },
            validation: Rule => Rule.required()
        }
    ],
    preview: {
        select: {
            title: 'title',
            pointCount: 'points.length',
            image: 'image'
        },
        prepare({ title, pointCount = 0, image }) {
            return {
                title: title || 'Why Choose Us Section',
                subtitle: `${pointCount} point${pointCount === 1 ? '' : 's'}`,
                media: image
            }
        }
    }
} 